(() => {
  if (window.nxtVisualLoaded) return;
  window.nxtVisualLoaded = true;
  const preference = matchMedia('(prefers-reduced-motion: reduce)');
  const initialized = new WeakSet();
  const cleanups = new WeakMap();
  const active = new Set();
  const ease = 'cubic-bezier(.22,1,.36,1)';
  const settle = () => { for (const animation of active) animation.cancel(); active.clear(); };
  function play(element, frames, options) {
    if (!element || preference.matches || !Element.prototype.animate || element.contains(document.activeElement)) return;
    const animation = element.animate(frames, {easing:ease,fill:'backwards',...options});
    active.add(animation);
    animation.addEventListener('cancel', () => active.delete(animation), {once:true});
    animation.addEventListener('finish', () => { animation.cancel(); active.delete(animation); }, {once:true});
  }
  function rise(element, delay=0, distance=14, duration=520, opacity=.4) {
    play(element,[{opacity,transform:`translateY(${distance}px)`},{opacity:1,transform:'none'}],{duration,delay});
  }
  function initialize(root) {
    if (initialized.has(root)) return;
    initialized.add(root);
    const hero=root.querySelector('.hero');
    let widgetObserver;
    if(hero&&'IntersectionObserver' in window){
      widgetObserver=new IntersectionObserver(entries=>{
        document.body.classList.toggle('nxt-hero-zone',entries.some(entry=>entry.isIntersecting));
      });
      widgetObserver.observe(hero);
      cleanups.set(root,()=>{widgetObserver.disconnect();document.body.classList.remove('nxt-hero-zone');});
    }
    const edit = root.querySelector('[data-nxt-edit]');
    if (edit) {
      const tabs = [...edit.querySelectorAll('[role="tab"]')];
      const panels = [...edit.querySelectorAll('[role="tabpanel"]')];
      function select(tab, focus=false) {
        tabs.forEach(button => { const yes=button===tab;button.setAttribute('aria-selected',String(yes));button.tabIndex=yes?0:-1; });
        panels.forEach(panel => { panel.hidden=panel.id!==tab.getAttribute('aria-controls'); });
        edit.querySelector('[data-edit-lead]').textContent=tab.dataset.lead;
        edit.querySelector('[data-edit-accent]').textContent=tab.dataset.accent;
        edit.querySelector('[data-edit-note]').textContent=tab.dataset.note;
        edit.querySelector('[data-edit-link]').href=tab.dataset.link;
        edit.querySelector('[data-edit-link-label]').textContent=tab.dataset.linkLabel;
        if (focus) tab.focus();
      }
      tabs.forEach((tab,index) => {
        tab.addEventListener('click',() => select(tab));
        tab.addEventListener('keydown',event => {
          let next;
          if(event.key==='ArrowRight')next=(index+1)%tabs.length;
          if(event.key==='ArrowLeft')next=(index-1+tabs.length)%tabs.length;
          if(event.key==='Home')next=0;
          if(event.key==='End')next=tabs.length-1;
          if(next!==undefined){event.preventDefault();select(tabs[next],true);}
        });
      });
    }
    if (document.body.dataset.nxtMotion!=='true' || preference.matches || window.Shopify?.designMode || !Element.prototype.animate) return;
    let observer;
    if(hero && scrollY<100 && !document.hidden){
      const ready=document.fonts?document.fonts.ready:Promise.resolve();
      Promise.race([ready,new Promise(resolve=>setTimeout(resolve,200))]).then(()=>{
        if(!hero.isConnected||preference.matches||scrollY>100)return;
        rise(hero.querySelector('h1'),0,12,540,.45);
        rise(hero.querySelector('.hero-content>p'),90,10,500,.45);
        const buttons=hero.querySelectorAll('.hero-buttons>a');
        rise(buttons[0],170,8,460,.55);rise(buttons[1],230,8,460,.55);
      });
    }
    if('IntersectionObserver' in window){
      const seen=new WeakSet();
      const categories=[...root.querySelectorAll('.world')];
      observer=new IntersectionObserver(entries=>{
        for(const {target,isIntersecting} of entries){
          if(!isIntersecting||seen.has(target))continue;
          seen.add(target);observer.unobserve(target);
          const rank=categories.indexOf(target);
          rise(target,innerWidth>700&&rank>=0?rank*80:0);
          const stroke=target.querySelector('.signature-stroke');
          if(stroke)play(stroke,[{transform:'rotate(-1deg) scaleX(.05)'},{transform:'rotate(-1deg) scaleX(1)'}],{duration:620,delay:140});
        }
      },{threshold:.08,rootMargin:'0px 0px -24px 0px'});
      root.querySelectorAll('.choose .section-heading,.world,.edit .section-heading,.custom-visual,.custom-copy,.hope>img,.hope>div,.club>div,.club>a').forEach(el=>observer.observe(el));
    }
    cleanups.set(root,()=>{observer?.disconnect();widgetObserver?.disconnect();if(hero)document.body.classList.remove('nxt-hero-zone');});
  }
  function scan(container=document){if(container.matches?.('[data-nxt-visual]'))initialize(container);container.querySelectorAll('[data-nxt-visual]').forEach(initialize);}
  scan();
  document.addEventListener('shopify:section:load',e=>scan(e.target));
  document.addEventListener('shopify:section:unload',e=>{e.target.querySelectorAll('[data-nxt-visual]').forEach(root=>cleanups.get(root)?.());settle();});
  document.addEventListener('shopify:block:select',e=>{const panel=e.target.closest('[role="tabpanel"]');if(panel){const tab=document.getElementById(panel.getAttribute('aria-labelledby'));tab?.click();}});
  document.addEventListener('focusin',settle);
  document.addEventListener('click',e=>{if(e.target.closest('a[href^="#"]'))settle();});
  document.addEventListener('visibilitychange',()=>{if(document.hidden)settle();});
  preference.addEventListener('change',()=>{if(preference.matches){document.querySelectorAll('[data-nxt-visual]').forEach(root=>cleanups.get(root)?.());settle();}});
  window.addEventListener('pagehide',settle);
})();
